import { baseURL } from "../../util/Constant";
import { getAllUsers, getMe, loginUser, registerUser } from "../redux/authSlice";
import { getMessage } from "../redux/messageSlice";



//Register User
export const registerUserFetch = (username, password) => (dispatch) => {
  fetch(`${baseURL}/auth/register`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ username, password }),
  })
    .then((res) => res.json())
    .then((data) => {
      console.log(data);
      
      if (data.token) {
        window.localStorage.setItem("token", data.token);
        window.localStorage.setItem('user', JSON.stringify(data.user));
        window.localStorage.setItem("rool", data.user.rool);
      }
      dispatch(registerUser(data));
    })
    .catch((error) => {
      console.log(error);
    });
};

//Login User
export const loginUserFetch = (username, password) => (dispatch) => {
  fetch(`${baseURL}/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ username, password }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.errorCode) {
        dispatch(getMessage(data.message));
        return;
      }
      if (data.token) {
        window.localStorage.setItem("token", data.token);
        window.localStorage.setItem('user', JSON.stringify(data.user));
        window.localStorage.setItem("rool", data.user.rool);
      }
      dispatch(loginUser(data));
    })
    .catch((error) => {
      console.log(error);
    });
};

//Login User
export const getMeFetch = () => (dispatch) => {
  fetch(`${baseURL}/auth/me`, { method: "GET" })
    .then((res) => res.json())
    .then((data) => {
      if (data.errorCode) {
        dispatch(getMessage(data.message));
        return;
      }
      dispatch(getMe(data));
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getAllUser = () => (dispatch) => {
  
  fetch(`${baseURL}/auth/get`, { method: "GET" })
    .then((res) => res.json())
    .then((data) => {
      if (data.errorCode) {
        dispatch(getMessage(data.message));
        return;
      }
     dispatch(getAllUsers(data));
    })
    .catch((error) => {
      console.log(error);
    });
};


export const putUpdateUser = (item, rool, fullname, email, password) =>()=>{
  
  fetch(`${baseURL}/auth/update`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({id: item._id, rool, fullname, email, password}),
  })
    .then((res) => res.json())
    .then((data) => {
      
      //dispatch(registerUser(data));
    })
    .catch((error) => {
      console.log(error);
    });
}

export const deleteUserFetch = (id) => (dispatch) => {
  fetch(`${baseURL}/auth/delete`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id }),
  })
    .then((res) => res.json())
    .then((data) => {
      dispatch(getAllUser());
    })
    .catch((error) => {
      console.log(error);
    });
};
